import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, LoadingController } from '@ionic/angular';
import { debounceTime } from 'rxjs/operators';
import { Navigator } from 'src/app/components/menu/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { BalanceModel } from 'src/app/models/balance-model';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { AddressService } from 'src/app/services/address/address.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';

@Component({
  selector: 'app-withdrawal-pnm',
  templateUrl: './withdrawal-pnm.component.html',
  styleUrls: ['./withdrawal-pnm.component.scss'],
})

export class WithdrawalPnmComponent extends WithdrawalBaseComponent implements OnInit {
    @ViewChild(IonContent) content: IonContent;
    
    public loading: any;
    public labels: DepositMainLabels;
    public error = null;
    public withdrwalSuccess = false;
    public accountBalances: BalanceModel;
    
    public withdrawalForm: FormGroup;

    public amount: AbstractControl;
    public currency_code: AbstractControl;
    public payment_type_code: AbstractControl;
    public buttonDisabled: boolean = false;

    showClientError: boolean = false;

    showForm: boolean = true;
    paymentMethodList = {};
    clientError: { result: number; code: string; message: string; payload: string; };



    constructor(
        public addressService: AddressService,
        public loadingController: LoadingController,
        public cashierService: CashierService,
        public cashierContentService: CashierContentService,
        public navigator:Navigator,
        public events:EventsService,
        public withdrawService:WithdrawalService,
        public balanceService:AccountBalanceService,
        public utils:UtilsService,
        public configService: ConfigService,
        public successMessageService: SuccessMessageService
    ){
        super();
        this.successMessageService.clearMessage();
        this.error = null;
        this.labels = new DepositMainModel();
    }

    ngAfterViewInit(){
        // let fileName = this.configService.getState() == 'Pennsylvania' ? 'casinocage-pa': 'casinocage-nj';
        let fileName = 'pnm';

        this.cashierContentService.getPageConfig(fileName).then((response: DepositMainLabels) => {
            this.labels = response;
        });
    }
  
    ngOnInit() {
        this.buttonDisabled = false;
        this.withdrawalForm = new FormGroup(
            {
                amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
                currency_code: new FormControl(''),
                payment_type_code: new FormControl(''),
                methodSelected: new FormControl('', [Validators.required])
            }
        )
        this.amount = this.withdrawalForm.get('amount');
        this.getExternalAccounts();
    }
    async showLoading() {
		this.loading = await this.loadingController.create({
			message: 'Loading...',
			duration: 1500
		});

		this.loading.present();
	}

    getExternalAccounts() {
        this.showLoading();
        this.withdrawService.callListExternalAccounts("PNMV2").subscribe( (list) => {
                if(list.result == 1 && list.payload.length != 0){
                    this.showForm = true;
                    list.payload.map((method) => { 
                        if(!!method.accountAdditionalInfo2){
                            if(method.accountAdditionalInfo2 in this.paymentMethodList){
                                this.paymentMethodList[method.accountAdditionalInfo2].push(method);
                            }else {
                                this.paymentMethodList[method.accountAdditionalInfo2] = [];
                                this.paymentMethodList[method.accountAdditionalInfo2].push(method);
                            }
                        }
                    });
            }else {
                this.showForm = false;
            }
        });

       
        setTimeout(() => {
            console.log(this.paymentMethodList);
        }, 2000);
        
    }
    ionViewDidEnter() {
        this.successMessageService.clearMessage();
        this.onGetBalance();
        this.withdrwalSuccess = false;
    }

    onGetBalance() {    
        this.balanceService.getBalance().subscribe((balance: BalanceModel) => {
            this.accountBalances = balance
        });
        this.error = null;
    }

    onWithdraw() {
        this.buttonDisabled = true;
        this.successMessageService.clearMessage();
        this.error = null;
        this.showClientError = false;

        this.withdrawalForm.get("currency_code").setValue(this.cashierService.customer.preferredCurrency.currencyCode);
        this.withdrawalForm.get("payment_type_code").setValue("PNMV2");

        if(this.withdrawalForm.value.methodSelected.accountInfo !== null && this.withdrawalForm.value.methodSelected.accountInfo !== undefined){
            this.withdrawService.callWithdraw(this.withdrawalForm.value).pipe(debounceTime(300)).subscribe(
                (response: any) => {
                    // this.logger.log("callWithdraw response = ", response);
                    if (response && !!response.result ) {
                        // send the withdrawal event
                        let depositEventData: AffiliateTrackerCallbackParams = {
                            customer_id: this.cashierService.customer.customerId,
                            amount:     this.withdrawalForm.get('amount').value
                        }
                        setTimeout(() => this.events.publish('event:withdraw', depositEventData ), 2000);
                        this.amount.setValue('');
                        this.amount.markAsPristine();
                        this.amount.markAsUntouched();
                        this.successMessageService.setMessage('Your withdrawal request has been received.');
                        this.balanceService.updateBalance();
                        this.content.scrollToTop();
                        this.withdrwalSuccess = true;
    
                        this.buttonDisabled = false;
                    }
                },
                (error) => {
                    // handle all deposit errors in base
                    this.error = this.handleError(error);
                    // this.logger.log("callWithdraw error = ", error);
                    this.buttonDisabled = false;
                    this.content.scrollToTop(100)
                }
            )
            this.error = null;
        }else {
            this.buttonDisabled = false;
            this.content.scrollToTop(100)
            this.showClientError = true;
            this.clientError = {
                "result" : 0,
                "code" : "ACCOUNT_ID_MISSING",
                "message" : "Please contact customer support",
                "payload" : "Please contact customer support"
              };           
        }       
    }

}
